import React, { useRef } from 'react';
import { useSearchBox } from '../../../contexts/SearchBoxContext';
import { getSearchPlaceholder } from '../../../tools/searchPlaceholder';
import FloatingSearchBarInput from '../../FloatingSearchBar/FloatingSearchBarInput';

interface SearchBoxIAProps {
  placeholderSentences?: string[];
}

const SearchBoxIA: React.FC<SearchBoxIAProps> = ({ placeholderSentences }) => {
  const [query, setQuery] = React.useState('');
  const onChange = (e: string) => setQuery(e);
  const { searchBoxPosition, setSearchBoxPosition } = useSearchBox();
  const searchBoxIARef = useRef(null);

  const updateSearchBoxIAPosition = () => {
    if (searchBoxPosition !== searchBoxIARef.current.getBoundingClientRect().bottom) {
      setSearchBoxPosition({
        bottomPosition: searchBoxIARef.current.getBoundingClientRect().bottom + window.scrollY,
      });
    }
  };

  const placeholder = getSearchPlaceholder(placeholderSentences);

  React.useEffect(() => {
    updateSearchBoxIAPosition();
  }, []);
  React.useEffect(() => {
    window.addEventListener('resize', updateSearchBoxIAPosition);
    return () => {
      window.removeEventListener('resize', updateSearchBoxIAPosition);
    };
  }, []);

  return (
    <div className="searchBoxIA" ref={searchBoxIARef}>
      <FloatingSearchBarInput
        isFocus={false}
        placeholder={placeholder}
        onInputChange={onChange}
        input={query}
        isDefault={true}
      />
    </div>
  );
};

export default SearchBoxIA;
